import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Divider,
  Button,
  DialogActions,
  Card,
  CardContent,
  Chip,
  Alert
} from '@mui/material';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const MarketAnalysisModal = ({ 
  open, 
  onClose, 
  selectedVector, 
  analysisData 
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullWidth 
      maxWidth="lg"
      sx={{ 
        "& .MuiDialog-paper": { 
          width: "90vw",  
          maxWidth: "1200px", 
          minWidth: "300px",
          overflowX: "hidden"
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {selectedVector} Analysis
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onClose}
          sx={{ minWidth: '80px' }}
        >
          OK
        </Button>
      </DialogTitle>
      <DialogContent 
        sx={{ 
          display: "flex", 
          flexDirection: "column", 
          overflowX: "hidden", 
          wordBreak: "break-word", 
          whiteSpace: "pre-wrap", 
          width: "100%",
          padding: "12px",
          gap: 1
        }}
      >
        {analysisData ? (
          <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 1 }}>
            {/* Result Section */}
            <Card elevation={1} sx={{ backgroundColor: '#f8f9fa' }}>
              <CardContent sx={{ padding: '12px !important' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50', fontSize: '1.1rem' }}>
                    📊 Result
                  </Typography>
                </Box>
                <Box sx={{ 
                  backgroundColor: 'white',
                  padding: 1.5,
                  borderRadius: 1,
                  border: '1px solid #e0e0e0'
                }}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: '0.9rem', 
                      lineHeight: 1.4, 
                      whiteSpace: 'pre-line',
                      '& strong': { fontWeight: 'bold', color: '#2c3e50' }
                    }}
                    dangerouslySetInnerHTML={{
                      __html: (analysisData.result || "N/A").replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                    }}
                  />
                </Box>
              </CardContent>
            </Card>
            
            {/* Purpose Section */}
            {analysisData.purpose && (
              <Card elevation={1} sx={{ backgroundColor: '#f0f8ff' }}>
                <CardContent sx={{ padding: '12px !important' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2c3e50', fontSize: '1.1rem' }}>
                      🎯 Purpose
                    </Typography>
                  </Box>
                  <Box sx={{ 
                    backgroundColor: 'white',
                    padding: 1.5,
                    borderRadius: 1,
                    border: '1px solid #e0e0e0'
                  }}>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        fontSize: '0.9rem', 
                        lineHeight: 1.4, 
                        whiteSpace: 'pre-line',
                        '& strong': { fontWeight: 'bold', color: '#2c3e50' }
                      }}
                      dangerouslySetInnerHTML={{
                        __html: (analysisData.purpose || "N/A").replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                      }}
                    />
                  </Box>
                </CardContent>
              </Card>
            )}
          </Box>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '150px' }}>
            <Typography variant="h6" color="text.secondary">Loading analysis...</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: '16px' }}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={onClose}
          sx={{ minWidth: '80px' }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MarketAnalysisModal;
